import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import { ActionButton } from 'components/MyGarage2.0/components/SharedStyles'
import Button from 'components/common/Button/Button'
import {
  VIEW_VEHICLE_DETAILS_BUTTON_LABEL
} from 'components/MyGarage2.0/constants'
import { SCHEDULE_APPOINTMENT, REQUEST_APPOINTMENT } from 'constant'

const DetailsLinks = ({
  navigateToVehicleDetailsPage,
  isE2EAppointment,
  navigateToQuoteHandler,
  activeVehicle = false
}) =>
  <>
    <RequestAppointmentButton
      data-at-myaccount-makeanappointment
      activeVehicle={ activeVehicle }
      narrow
      onClick={ navigateToQuoteHandler } >
      { isE2EAppointment ? SCHEDULE_APPOINTMENT : REQUEST_APPOINTMENT}
    </RequestAppointmentButton>
    <ViewVehicleDetailsButton
      narrow
      activeVehicle={ activeVehicle }
      data-at-garage-vehicle-viewservicehistory
      onClick={ navigateToVehicleDetailsPage }>
      {VIEW_VEHICLE_DETAILS_BUTTON_LABEL}
    </ViewVehicleDetailsButton>
  </>

DetailsLinks.propTypes = {
  activeVehicle: PropTypes.bool,
  isE2EAppointment: PropTypes.bool,
  navigateToQuoteHandler: PropTypes.func,
  navigateToVehicleDetailsPage: PropTypes.func
}

export default DetailsLinks

const RequestAppointmentButton = styled(ActionButton)`
  margin-bottom: 25px;
  ${props => props.activeVehicle && css`
    @media (max-width: 1024px) {
      padding: 7px 15px 8px;
    }
  `}

  @media (max-width: 500px) {
    padding: 7px 8px 8px !important;
    font-size: 10px;
  }
`

const ViewVehicleDetailsButton = styled(Button)`
  ${props => props.activeVehicle && css`
    width: 100%;

    @media (max-width: 1024px) {
      width: auto;
      padding: 7px 15px 8px;
    }
  `}
  background: ${Theme.colors.white};
  color: ${Theme.colors.bright_red_new};
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background: ${Theme.colors.bright_red_new};
    border-color: ${Theme.colors.bright_red_new};
  }

  @media (max-width: 500px) {
    font-size: 10px;
    padding: 7px 8px 8px;
  }
`
